module.exports = __webpack_public_path__ + "aa31e318301216a0f483b3bdc153b44f.png";